import { createStore } from 'vuex'

export default createStore({
  state: {
    me: null,
    charged: null,
    lastApp: null,
    appHistory: null,
    apps: null,
  },
  mutations: {
    setMe(state, val) {
      state.me = val;;
    },
    setCharged(state, val) {
      state.charged = val;;
    },
    setLastApp(state, val) {
      state.lastApp = val;;
    },
    setAppHistory(state, val) {
      state.appHistory = val;;
    },
    setApps(state, val) {
      state.apps = val;;
    }
  }
})
